import { css } from 'styled-components'
import { AspiraStack } from '@chegg-wt/core/theme/fanta/fonts'

import { AspiraRegular, FontSize16 } from './fonts'
import { ButtonReset } from './resets'
import { Ellipsize } from './typography'

export const ButtonBehavior = css`
  &:disabled {
    cursor: default;
    opacity: 0.25;
  }
  &:active {
    transform: translateY(2px);
  }
`

export const SpecialOutline = css`
  ${AspiraStack};
  border: 2px solid ${({ theme }) => theme.Colors.forInterface.interfaceColor01};
  background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor11};
  color: ${({ theme }) => theme.Colors.forInterface.interfaceColor01};
  &:hover {
    background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor24};
    color: ${({ theme }) => theme.Colors.forInterface.interfaceColor01};
    border-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor01};
  }
`

export const Special = css`
  ${AspiraStack};
  border-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor01};
  background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor01};
  color: #fff;
  &:hover {
    border-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor23};
    background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor23};
    color: #fff;
  }
  ${ButtonBehavior};
`

export const Primary = css`
  ${AspiraStack};
  border-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor06};
  background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor06};
  color: #ffffff;
  &:hover {
    border-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor25};
    background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor25};
  }
  ${ButtonBehavior};
`

export const PrimaryOutline = css`
  ${AspiraStack};
  background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor11};
  border: 2px solid ${({ theme }) => theme.Colors.forInterface.interfaceColor06};
  color: ${({ theme }) => theme.Colors.forInterface.interfaceColor06};
  &:hover {
    background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor06};
    color: ${({ theme }) => theme.Colors.forInterface.interfaceColor11};
  }
  ${ButtonBehavior};
`

export const Secondary = css`
  ${AspiraStack};
  border-color: #ddd;
  background-color: #ddd;
  color: ${({ theme }) => theme.Colors.forInterface.interfaceColor16};
  &:hover {
    border-color: #ccc;
    background-color: #ccc;
  }
  &:active,
  &:focus {
    background-color: #cbcbcb;
    border-color: #cbcbcb;
  }
  ${ButtonBehavior};
`

export const SecondaryOutline = css`
  ${AspiraStack};
  border-color: #ddd;
  border-width: 2px;
  background-color: rgba(255, 255, 255, 0);
  color: ${({ theme }) => theme.Colors.forInterface.interfaceColor16};
  &:hover {
    background-color: rgba(221, 221, 221, 0.25);
  }
  ${ButtonBehavior};
`

export const White = css`
  ${AspiraStack};
  border-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor12};
  background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor12};
  color: ${({ theme }) => theme.Colors.forInterface.interfaceColor16};
  &:hover {
    border-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor12};
    background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor12};
  }
  ${ButtonBehavior};
`

export const WhiteOutline = css`
  ${AspiraStack};
  border-width: 2px;
  border-color: #fff;
  background-color: rgba(255, 255, 255, 0);
  color: #fff;
  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
  ${ButtonBehavior};
`

export const Large = css`
  font-weight: bold;
  height: 44px;
  line-height: 44px;
  border-radius: 8px;
  font-size: 20px;
  padding: 0 40px;
`

export const Small = css`
  font-weight: bold;
  height: 34px;
  line-height: 34px;
  border-radius: 6px;
  font-size: 20px;
  padding: 0 30px;
`

export const Mini = css`
  font-weight: bold;
  height: 30px;
  line-height: 30px;
  border-radius: 4px;
  font-size: 16px;
  padding: 0 20px;
`

export const DropdownButton = css`
  ${ButtonReset};
  ${Ellipsize};
  ${AspiraRegular};
  ${FontSize16};
  border-bottom: 1px solid ${({ theme }) => theme.Colors.forInterface.interfaceColor13};
  box-sizing: border-box;
  overflow-x: hidden;
  position: relative;
  text-overflow: ellipsis;
  width: 100%;
  &:hover,
  :focus,
  :active {
    background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor19};
  }
  display: flex;
  align-items: center;
`

export const DropdownButtonMedium = css`
  ${DropdownButton};
  height: 65px;
`

export const DropdownButtonSmall = css`
  ${DropdownButton};
  height: 50px;
  padding: 0px;
`
